module.exports = __webpack_public_path__ + "img/es_es.04e0c7bc.svg";